export default function ResetPasswordForm() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            uid: "<",
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            Users,
            PasswordReqEx,
            $timeout,
            $location
        ) {
            $scope.debug = false;
            $scope.newpasswordSet = false;

            $scope.passwordReqEx = PasswordReqEx;

            $scope.stringOfIllegalChars = "";

            $scope.resetPassword = (newPassword) => {
                /**
                 * Any form validation errors ?
                 */
                if (!Object.keys($scope.form.$error).length) {
                    Users.resetPassword($scope.uid, newPassword).then(
                        () => {
                            $scope.newpasswordSet = true;
                            $scope.successMessage =
                                "Sådan, dit kodeord er ændret.. Vent lidt, så stiller jeg dig om til login.";
                            $timeout(() => {
                                $location.path("/account/profile");
                            }, 5000);
                        },
                        (err) => {
                            console.log(err);
                        }
                    );
                } else {
                    // console.log("not allowed");
                }
            };
        },
    };
}
